const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]{3}$/;
// 6-18 envelope matches BE reAccountNo (^[0-9]{6,18}$). isPlausibleAccountNumber
// gates the onboarding penny-drop trigger (BankVerificationEffect) AND the
// edit-flow validAccountNumber (editValidators). Changes here move the paid
// Cashfree API cadence in both flows — sibling test coverage: bankVerify /
// BankVerificationEffect (onboarding), editValidators (edit).
const ACCOUNT_MIN_LEN = 6;
const ACCOUNT_MAX_LEN = 18;

export function isValidPanFormat(pan: string): boolean {
  return PAN_REGEX.test(pan);
}

export function isValidIfscFormat(ifsc: string): boolean {
  return IFSC_REGEX.test(ifsc);
}

export function isValidGstinFormat(gstin: string): boolean {
  return GSTIN_REGEX.test(gstin);
}

export function isPlausibleAccountNumber(acc: string): boolean {
  const t = acc.trim();
  return (
    /^\d+$/.test(t) && t.length >= ACCOUNT_MIN_LEN && t.length <= ACCOUNT_MAX_LEN
  );
}
